import { apiFetch } from './api-client';

export interface MorningBrief {
    // Define the expected structure returned from the morning brief endpoint
    summary: string;
    highlights: string[];
    sentiment: string;
    [key: string]: unknown;
}

export interface SectorBrief {
    sector: string;
    analysis: string;
    sentiment: string;
    [key: string]: unknown;
}

/** Fetch AI-classified and ranked priority news feed */
export async function fetchLLMPriorityFeed(): Promise<any[]> {
    try {
        const result = await apiFetch<{ items: any[] }>('/llm/priority-feed', { cacheTTL: 300 });
        return result.data.items || [];
    } catch (err) {
        console.warn('Failed to fetch LLM priority feed:', err);
        return [];
    }
}

/** Fetch AI-generated morning market brief */
export async function fetchLLMMorningBrief(): Promise<MorningBrief | null> {
    try {
        const result = await apiFetch<MorningBrief>('/llm/morning-brief', { cacheTTL: 3600 }); // once per hour or morning
        return result.data;
    } catch (err) {
        console.warn('Failed to fetch LLM morning brief:', err);
        return null;
    }
}

/** Explain why a news item matters */
export async function fetchLLMWhyItMatters(headline: string): Promise<string> {
    try {
        const response = await fetch('/api/llm/why-it-matters', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ headline }),
        });
        if (!response.ok) throw new Error('Failed to fetch explanation');
        const data = await response.json();
        return data.explanation || data.impact || 'Explanation not available.';
    } catch (err) {
        console.warn('Failed to fetch LLM explanation:', err);
        return 'Analysis unavailable at this moment due to an API error.';
    }
}

/** Fetch sector analysis brief */
export async function fetchLLMSectorBrief(sector?: string): Promise<any> {
    try {
        const params = sector ? { sector } : undefined;
        const result = await apiFetch<any>('/llm/sector-brief', {
            cacheTTL: 3600,
            params
        });
        return result.data;
    } catch (err) {
        console.warn(`Failed to fetch LLM sector brief for ${sector}:`, err);
        return null;
    }
}
